export default "__VITE_ASSET__BfiuVsTT__"